import { createIcon } from '@chakra-ui/icons';

export const FileAssessment = createIcon({
  displayName: 'FileAssessment',
  viewBox: '0 0 44 44',
  path: [
    <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_219_12579)">
        <path
          d="M22.6593 43.3441C34.4475 43.3441 44.0037 33.7879 44.0037 21.9997C44.0037 10.2115 34.4475 0.655273 22.6593 0.655273C10.8711 0.655273 1.31494 10.2115 1.31494 21.9997C1.31494 33.7879 10.8711 43.3441 22.6593 43.3441Z"
          fill="#FEF3DF"
        />
        <path
          d="M23.5445 38.2306C28.1133 38.2306 31.8171 37.7774 31.8171 37.2183C31.8171 36.6593 28.1133 36.2061 23.5445 36.2061C18.9757 36.2061 15.272 36.6593 15.272 37.2183C15.272 37.7774 18.9757 38.2306 23.5445 38.2306Z"
          fill="#F6D59D"
        />
        <path
          d="M13.7603 33.3798C13.7602 33.4623 13.7764 33.5441 13.808 33.6204C13.8395 33.6967 13.8858 33.766 13.9442 33.8244C14.0026 33.8828 14.0719 33.9291 14.1482 33.9606C14.2245 33.9922 14.3063 34.0084 14.3888 34.0083H32.6223C32.789 34.0083 32.9489 33.9421 33.0668 33.8242C33.1847 33.7064 33.2509 33.5465 33.2509 33.3798V12.9457L27.9068 7.60156H14.3889C14.3061 7.60152 14.2242 7.61781 14.1477 7.64948C14.0713 7.68119 14.0019 7.72771 13.9434 7.7863C13.8851 7.84489 13.8388 7.9145 13.8074 7.99108C13.7759 8.06757 13.7599 8.14959 13.7603 8.23231V33.3798Z"
          fill="white"
        />
        <path
          d="M13.7603 33.3798C13.7602 33.4623 13.7764 33.5441 13.808 33.6204C13.8395 33.6967 13.8858 33.766 13.9442 33.8244C14.0026 33.8828 14.0719 33.9291 14.1482 33.9606C14.2245 33.9922 14.3063 34.0084 14.3888 34.0083H32.6223C32.789 34.0083 32.9489 33.9421 33.0668 33.8242C33.1847 33.7064 33.2509 33.5465 33.2509 33.3798V12.9457L27.9068 7.60156H14.3889C14.3061 7.60152 14.2242 7.61781 14.1477 7.64948C14.0713 7.68119 14.0019 7.72771 13.9434 7.7863C13.8851 7.84489 13.8388 7.9145 13.8074 7.99108C13.7759 8.06757 13.7599 8.14959 13.7603 8.23231V33.3798Z"
          stroke="#453924"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.245 12.9457H28.4878C28.4107 12.9457 28.3344 12.9305 28.2632 12.901C28.192 12.8715 28.1273 12.8283 28.0728 12.7738C28.0183 12.7193 27.9751 12.6546 27.9455 12.5833C27.916 12.5121 27.9009 12.4358 27.9009 12.3587V7.60156L33.245 12.9457Z"
          fill="#F6D59D"
          stroke="#453924"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.8921 13.3262H8.80583C8.43331 13.3262 8.13135 13.6282 8.13135 14.0007V21.0272C8.13135 21.3998 8.43331 21.7017 8.80583 21.7017H23.8921C24.2645 21.7017 24.5665 21.3998 24.5665 21.0272V14.0007C24.5665 13.6282 24.2645 13.3262 23.8921 13.3262Z"
          fill="#EBBF76"
          stroke="#453924"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.2681 19.6618V15.4004C11.2681 15.4004 13.4949 15.0551 13.4949 16.5909C13.4949 18.1266 11.2681 17.7808 11.2681 17.7808"
          stroke="white"
          strokeWidth="1.32"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.272 19.6628V15.4014C15.272 15.4014 17.614 15.4014 17.614 17.5321C17.614 19.6628 15.272 19.6628 15.272 19.6628Z"
          stroke="white"
          strokeWidth="1.32"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5688 19.6628V15.4014H21.4418"
          stroke="white"
          strokeWidth="1.32"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5688 17.5303H21.4418"
          stroke="white"
          strokeWidth="1.32"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_219_12579">
          <rect width="44" height="44" fill="white" transform="translate(0.666504)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
